import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { NEXT_BACK } from '../../../config/setup/setup';
import ThemeContext from '../../../providers/ThemeProvider';

export const GiftFinderFiltersButton = ({ orientation, onClick, text }) => {
  const theme = useContext(ThemeContext);

  return (
    <>
      <button
        aria-label={orientation}
        className={classNames('filter-btn', {
          'filter-btn--back': orientation === NEXT_BACK.BACK,
          'filter-btn--next': orientation === NEXT_BACK.NEXT,
        })}
        onClick={onClick}
        type="button"
      >
        {orientation ? orientation : text}
      </button>
      <style jsx>{`
        .filter-btn {
          border: 1px solid red;
          background: ${theme.colors.giftButton};
          border: none;
          border-radius: 11px;
          font-size: 12px;
          min-height: 23px;
          line-height: 23px;
          padding: 0 10px;
          position: relative;
        }
        .filter-btn:after {
          border: 5px solid transparent;
          content: '';
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
        }
        .filter-btn--next {
          float: right;
          padding-right: 30px;
        }
        .filter-btn--next:after {
          border-left: 10px solid ${theme.colors.giftButtonArrow};
          right: 5px;
        }
        .filter-btn--back {
          float: left;
          padding-left: 30px;
        }
        .filter-btn--back:after {
          border-right: 10px solid ${theme.colors.giftButtonArrow};
          left: 5px;
        }
      `}</style>
    </>
  );
};

GiftFinderFiltersButton.propTypes = {
  onClick: PropTypes.func,
  orientation: PropTypes.oneOf([NEXT_BACK.NEXT, NEXT_BACK.BACK]),
  text: PropTypes.string,
};
